'use es6';

export const DESIGN = 8;